import action from 'app/lib/action';
import {DOCS_AND_GOODS} from '../constants/actionTypes';

export default {
    clear : () => action(DOCS_AND_GOODS.CLEAR)()
};